import React from 'react';
import ThemeEmpty from '@base/lib/ThemeEmpty';
import { useRouter } from 'next/router';
import { DEBUG_SERVER } from 'base/config/constant';
import cn from 'classnames';
import styles from '@pro/lib/ErrorDisplay.module.less';

type ExtendError = Error & {
    request?: string;
};

type ErrorDisplayProps = {
    error?: ExtendError;
    errors?: ExtendError[];
    errorTip?: string;
    middle?: boolean;
};

const getTip = (errorTip?: string, errors?: ExtendError[], error?: ExtendError): React.ReactNode => {
    if (errorTip) {
        return errorTip;
    }
    if (errors) {
        return (
            <div>
                {errors.map((error, index) => (
                    <p key={index}>{error.message}{index === errors.length - 1 ? '.' : ','}</p>
                ))}
            </div>
        )
    }
    if (error) {
        return error.message;
    }
    return 'Oops! Something is wrong.'
};

const formatError = (error: ExtendError) => {
    if (error.request) {
        try {
            error.request = JSON.parse(error.request);
            // @ts-ignore
            if (error.request.body) {
                // @ts-ignore
                error.request.body = JSON.parse(error.request.body);
            }
        } catch (e) {
        }
    }
    return JSON.stringify(error, null, 4);
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = props => {
    const router = useRouter();
    const {
        errorTip,
        error,
        errors,
        middle = false
    } = props;

    return (
        <div className={cn(styles['error-display'], 'g-bg', { [styles.middle]: middle })}>
            <ThemeEmpty
                className="wrapper"
                tip={getTip(errorTip, errors, error)}
                extra={
                    (process.env.NODE_ENV === 'development' || router.query[DEBUG_SERVER] === '1') && (errors || error)
                        ? (
                            <div className="text-left">
                                {errors && errors.map((item, index) => (
                                    <pre key={index} className={styles.pre}>
                                {formatError(item)}
                            </pre>
                                ))}
                                {error && (
                                    <pre className={styles.pre}>
                                {formatError(error)}
                            </pre>
                                )}
                            </div>
                        )
                        : void 0
                }
            />
        </div>
    )
};

export default ErrorDisplay;